import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import InboxPagination from 'src/components/InboxPagination'

const WebhookLogsDialog = ({
  openWebhoooklogsDialog,
  handleCloseWebhookLogsDialog,
  integrationLogs,
  isLoadingIntegrationLogs,
  page,
  setPage,
  totalLogs,
  handleLimitChange,
  limit
}) => {
  return (
    <>
      <Dialog
        open={openWebhoooklogsDialog}
        onClose={handleCloseWebhookLogsDialog}
        sx={{
          '& .MuiDialog-paper': {
            width: { xs: '343px', md: '717px' },
            height: { xs: '312.9px', md: '345.5px' },
            maxWidth: '1000px',
            maxHeight: '780px',
            border: '1px solid #D7D9E6',
            borderRadius: '8px'
          }
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            height: { xs: '64px', md: '67px' },
            p: { xs: '16px', md: '16px 24px' }

          }}
        >
          <Typography
            sx={{
              fontSize: { xs: '14px', md: '17px' },
              fontWeight: 700,
              lineHeight: '20px'
            }}
          >
            Webhook Logs
          </Typography>
          <IconButton
            onClick={handleCloseWebhookLogsDialog}
            aria-label='close'
            sx={{
              border: '1px solid #E4E4E5',
              borderRadius: '6px',
              height: { xs: '32px', md: '35px' },
              width: { xs: '32px', md: '35px' }
            }}
          >
            <CloseIcon sx={{ fontSize: '15px', color: 'black' }} />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          height: { xs: '189.9px', md: '345.5px' },
          overflow: 'hidden'
        }}
        >
          {integrationLogs && integrationLogs.length > 0
            ? (
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>From</TableCell>
                      <TableCell>To</TableCell>
                      <TableCell>Event</TableCell>
                      <TableCell>Timestamp</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {integrationLogs?.map((log, index) => (
                      <TableRow key={index}>
                        <TableCell>{log?.from}</TableCell>
                        <TableCell>{log?.to}</TableCell>
                        <TableCell>{log?.eventType}</TableCell>
                        <TableCell>{log?.timestamp}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                {integrationLogs?.length > 0 && (
                  <Box sx={{ position: 'sticky', bottom: 0, width: '100%' }}>
                    <InboxPagination
                      page={page}
                      setPage={setPage}
                      total={totalLogs}
                      length={integrationLogs?.length}
                      limit={limit}
                      handleLimitChange={handleLimitChange}
                    />
                  </Box>
                )}
              </TableContainer>
              )
            : (
              <>
                <img
                  src='/assets/noLog.jpg' style={{
                    width: '330px',
                    height: '108px'
                  }}
                />
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <Typography sx={{ fontSize: { xs: '16px', md: '22px' }, fontWeight: 700 }}>No logs available</Typography>
                  <Typography sx={{ fontSize: { xs: '12px', md: '14px' }, fontWeight: 400, color: 'text.secondary' }}>Access a detailed history of all your webhook logs </Typography>
                  <Typography sx={{ fontSize: { xs: '12px', md: '14px' }, fontWeight: 400, color: 'text.secondary' }}> here for better tracking and insights</Typography>
                </Box>
              </>
              )}

        </DialogContent>

        <DialogActions sx={{
          justifyContent: 'space-between',
          width: '100%',
          height: { xs: '66px', md: '74px' },
          p: { xs: '16px', md: '16px 24px' }
        }}
        >
          <Button
            varint='outlined'
            sx={{
              border: '1px solid #E4E4E5',
              borderRadius: '8px',
              height: { xs: '34px', md: '42px' },
              width: { xs: '100%', md: '68px' },
              fontSize: { xs: '12px', md: '14px' },
              fontWeight: 600,
              p: { xs: '10px 14px', md: '10px 14px' }
            }}
            onClick={handleCloseWebhookLogsDialog}
          >
            Close
          </Button>
        </DialogActions>

      </Dialog>
    </>
  )
}

export default WebhookLogsDialog
